"use strict";
export var CurrencyField = /* @__PURE__ */ ((CurrencyField2) => {
  CurrencyField2["INPUT"] = "input";
  CurrencyField2["OUTPUT"] = "output";
  return CurrencyField2;
})(CurrencyField || {});
